import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '../../constants/endpoints.constants';
import { IWorkflowAccessKeyService } from '../../interfaces/workflow-access-key-service.interface';

export interface AccessKeyResponse {
  data: { access_key: string };
}
@Injectable({
  providedIn: 'root',
})
export class WorkflowAccessKeyService implements IWorkflowAccessKeyService {
  private readonly http = inject(HttpClient);

  refreshingAccessKeyTime = 1000 * 60 * 4; // 4 mins

  getStepAuthorizationKey(
    stepId: string | number,
    userId?: string | number | null,
    options?: { url?: string }
  ): Observable<AccessKeyResponse> {
    const params = userId
      ? new HttpParams().append('descendant_user_id', userId.toString())
      : undefined;

    const url =
      options?.url ??
      ENDPOINTS.Application.Flow.AccessKey.GetStepKey.replace(
        '{stepId}',
        stepId.toString()
      );

    return this.http.post<{ data: { access_key: string } }>(
      url,
      {},
      { params }
    );
  }

  refreshStepAuthorizationKey(
    stepId: string | number,
    options?: { url?: string }
  ) {
    const url =
      options?.url ??
      ENDPOINTS.Application.Flow.AccessKey.RefreshStepKey.replace(
        '{stepId}',
        stepId.toString()
      );
    return this.http.put<{ message: string }>(url, {});
  }

  getFlowAuthorizationKey(
    flowId: string | number
  ): Observable<AccessKeyResponse> {
    const url = ENDPOINTS.Application.Flow.AccessKey.GetFlowKey.replace(
      '{flowId}',
      flowId.toString()
    );

    return this.http.post<{ data: { access_key: string } }>(url, {});
  }

  refreshFlowAuthorizationKey(flowId: string | number) {
    const url = ENDPOINTS.Application.Flow.AccessKey.RefreshFlowKey.replace(
      '{flowId}',
      flowId.toString()
    );
    return this.http.put<{ message: string }>(url, {});
  }

  getPermissionsAccessKey(
    flowTemplate: string | number
  ): Observable<AccessKeyResponse> {
    const url =
      ENDPOINTS.Application.Flow.AccessKey.GeneratePermissionsAccessKey.replace(
        '{flowTemplate}',
        flowTemplate.toString()
      );
    return this.http.post<AccessKeyResponse>(url, {});
  }

  refreshPermissionsAccessKey(flowTemplate: string | number) {
    const url =
      ENDPOINTS.Application.Flow.AccessKey.RefreshPermissionsAccessKey.replace(
        '{flowTemplate}',
        flowTemplate.toString()
      );
    return this.http.put<{ message: string }>(url, {});
  }
}
